import { AuthManager } from "./auth/AuthManager.client";
import { TenantManager } from "./tenants/TenantManager.client";
import { MemberManager } from "./members/MemberManager.client";
import { DocumentManager } from "./documents/DocumentManager.client";
import { IAuthManager } from "./auth/IAuthManager";
import { IMemberManager } from "./members/IMemberManager";
import { IDocumentManager } from "./documents/IDocumentManager";
import { ITenantManager } from "./tenants/ITenantManager";

export class OmnibusManager {
  auth: IAuthManager;
  tenants: ITenantManager;
  members: IMemberManager;
  documents: IDocumentManager;

  constructor() {
    this.auth = new AuthManager();
    this.tenants = new TenantManager();
    this.members = new MemberManager();
    this.documents = new DocumentManager();
  }
}
